import React from 'react';
import Tooltip from '@atoms/new/tooltip';
import { getLiveLayoutColors } from './RunOfShow/helper/presentationLive';

const RollingCounter = ({ number = 100, layoutTheme }) => {
  const colors = getLiveLayoutColors(layoutTheme);
  const paddedDigits = String(number).padStart(3, '0');

  return (
    <Tooltip
      content="Interaction commenters"
      placement="top"
    >
      <div className="flex items-center gap-[2px] cursor-pointer">
        {[...paddedDigits].map((digit, idx) => (
          <DigitRoller key={idx} digit={digit} colors={colors} />
        ))}
      </div>
    </Tooltip>
  );
};

const DigitRoller = ({ digit, colors }) => {
  const digitHeight = 44;

  return (
    <div
      className="overflow-hidden"
      style={{ height: `${digitHeight}px`, width: '2rem' }}
    >
      <div
        className="transition-transform duration-300 ease-in-out"
        style={{ transform: `translateY(-${Number(digit) * digitHeight}px)` }}
      >
        {[...Array(10).keys()].map((d) => (
          <div
            key={d}
            className={`${colors.containerColor} w-8 h-11 rounded-lg shadow-lg inline-flex flex-col justify-center items-center`}
          >
            <div className={`${colors.textColor} text-3xl font-semibold font-['Inter']`}>
              {d}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RollingCounter;
